import {
  CarouselProductVariants,
  CarouselSectionTypes,
  CarouselTiledCards,
  ProductCarouselSlide,
} from '@dfh-corp-sites/ui'
import { Subscribe } from '@react-rxjs/core'
import React, { useMemo } from 'react'

import { useResultWithLeftEffect } from '../../../../hooks/useResultWithLeftEffect'
import useRetailPrices from '../../../../hooks/useRetailPrices'
import { useTestKitPrice } from '../../../../hooks/useTestKitPrice'
import { buildCarouselSlideProductData } from '../../../../lib/products/carousel'
import { useProductsBySkus } from '../../../../lib/products/products-by-skus'
import { constNull } from '../../../../utils/constant'
import { pluckData } from '../../../../utils/result'

export interface RelatedProductsCarouselProps {
  carouselTitle: string
  parentProductName: string
  relatedProductSkus: string[]
}

const RelatedProductsCarouselReactive: React.FC<RelatedProductsCarouselProps> = ({
  carouselTitle,
  parentProductName,
  relatedProductSkus,
}) => {
  const { shouldDisplayRetailPrice } = useRetailPrices()
  const { shouldShowTestKitPrice } = useTestKitPrice()
  const [, data] = useResultWithLeftEffect(
    useProductsBySkus(...relatedProductSkus),
    pluckData,
    constNull,
  )

  //transform the data to match the ProductCarouselSlide type
  const carouselSlides = useMemo<ProductCarouselSlide[]>(() => {
    return (data?.products ?? []).map((product) => ({
      _key: product.id,
      type: CarouselSectionTypes.Product,
      productData: buildCarouselSlideProductData({
        analyticsEventAppContext: 'related_products',
        product,
        showPrice: shouldShowTestKitPrice(product.sku),
        showRetailPrice: shouldDisplayRetailPrice,
      }),
    }))
  }, [data, shouldDisplayRetailPrice, shouldShowTestKitPrice])

  if (carouselSlides.length === 0) {
    return null
  }

  return (
    <div className="border-t border-brand-rule-grey">
      <CarouselTiledCards
        slides={carouselSlides}
        sliderType={CarouselSectionTypes.Product}
        productVariant={CarouselProductVariants.Light}
        title={`Users who bought ${parentProductName} also bought these products.`}
        subtitle={carouselTitle}
      />
    </div>
  )
}

const RelatedProductsCarousel: React.FC<RelatedProductsCarouselProps> = (props) => (
  <Subscribe>
    <RelatedProductsCarouselReactive {...props} />
  </Subscribe>
)

export default RelatedProductsCarousel
